module.exports = __webpack_public_path__ + "img/ondro.10ccd6dc.jpg";